<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        List
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="list"
      :loading="listLoader"
      :options.sync="options"
      :server-items-length="total"
      class="elevation-1 custom-icon-size mt-7"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <v-row class="custom-row pl-5 pr-5">
              <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
                <v-autocomplete
                  outlined
                  v-model="client"
                  :items="clients"
                  dense
                  chips
                  small-chips
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  @focus="fetchClientList"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  v-model="hs_code"
                  label="HS Code"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined v-model="sku" label="SKU"></v-text-field>
              </v-col>

              <v-col cols="12" sm="3">
                <v-autocomplete
                  outlined
                  v-model="status"
                  :items="statuses"
                  dense
                  chips
                  small-chips
                  item-text="text"
                  item-value="value"
                  label="Status"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                    :max="getEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                    :max="getEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                :sm="userCategory.user_category == 3 ? 6 : 9"
                class="pr-6"
              >
                <v-btn
                  color="white v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                  class="ml-4"
                  @click="clearAll"
                  style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </v-row>
            <v-divider class="mt-2 mb-2"></v-divider>
          </v-form>
        </template>
      </template>
      <template v-slot:[`item.dimensions`]="{ item }">
        <label>
          {{ item.weight }} kg | <strong>W:</strong> {{ item.width }} |
          <strong>H:</strong> {{ item.height }} | <strong>L:</strong>
          {{ item.length }}
        </label>
      </template>
      <template v-slot:[`item.created_at`]="{ item }">{{
        item.created_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
      }}</template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["userCategory"]),
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  data: () => ({
    dateMenu: false,
    dateMenuTo: false,
    from_date: null,
    to_date: null,
    headers: [
      {
        text: "Created At",
        value: "created_at",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },
      {
        text: "Client",
        value: "client_id",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },
      {
        text: "ASN / Product",
        value: "product_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Product Name ",
        value: "name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Brand",
        value: "brand",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Category",
        value: "category_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Selling Price",
        value: "unit_price",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Dimensions",
        value: "dimensions",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "HS Code",
        value: "hs_code",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },
    ],
    carriers: [],
    hs_code: null,
    sku: null,
    client: null,
    list: [],
    listLoader: false,
    filtersArr: {},
    clients: [],
    total: 0,
    options: {},
    status: "",
    statuses: [
      { text: "UNIWARE_UPDATED", value: "UNIWARE_UPDATED" },
      { text: "UNIWARE_FAILED", value: "UNIWARE_FAILED" },
      { text: "UPDATED", value: "UPDATED" },
      { text: "CREATED", value: "CREATED" },
    ],
  }),

  created() {
    this.fetchClientList();
  },
  watch: {
    options: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["snackBar", "getProductList", "fetchClient"]),
    clearAll() {
      (this.hs_code = null),
        (this.sku = null),
        (this.client = null),
        (this.filtersArr = {});
      this.status = null;
      this.to_date = null;
      this.from_date = null;
      this.fetchList();
    },
    clearDateInput(date) {
      if (date == "this.from_date") {
        this.from_date = null;
      } else {
        this.to_date = null;
      }
    },
    fetchClientList() {
      if (this.clients.length) return;

      if (this.clients.length === 0 && this.userCategory.user_category === 3) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "fulfillment,fulfillment_wid_last_mile",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    allFilters() {
      this.clientsLoader = true;
      let obj = {
        client_id: this.client,
        hs_code: this.hs_code,
        sku: this.sku,
        status: this.status,
        from_date: this.from_date,
        to_date: this.to_date,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getProductList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.listLoader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.listLoader = false;
        });
    },
    fetchList() {
      this.list = [];
      this.listLoader = true;
      this.getProductList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.listLoader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.listLoader = false;
        });
    },
  },
};
</script>
